import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../Layout";
import { fetchRequest } from "../../store/hashedHotCard/actions";
import { ApplicationState } from "../../store";
import HashedHotCardTable from "./hashedHotCardTable/HashedHotCardTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";


export default function HashedHotCard(): React.ReactElement {
  const dispatch = useDispatch();
  const classes = pageStyles();
  const session = useSession();
  const history = useHistory();

  useEffect(() => {
    dispatch(fetchRequest(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.hashedHotCard
  );
  const hashedHotCard = data || [];

  return (
    <Layout sessionData={session}>
      <main className={classes.content as string}>
        <div className={classes.appBarSpacer as string} />
        <Container maxWidth="lg" className={classes.container as string}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity="HashedHotCard"
                  heading="HotCard Management"
                  primaryButtonText="Add new Hotcard"
                  primaryButtonClickHandler={() => history.push("/hotcard/new")}
                />
              </Paper>
              <Box my={2}>
                <Paper>
                  {loading ? (
                    <ProgressIndicator />
                  ) : (
                    //@ts-ignore
                    <HashedHotCardTable data={hashedHotCard} />
                  )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
